module.exports = __webpack_public_path__ + "img/phone_k73.e5c510f0.png";